import React from "react";

import { Grid } from "@material-ui/core";

import { SubtleBadge } from "components/Badge";
import { CollapseLabel, FormCollapse } from "components/Form";
import { withNamespace } from "components/Form/FormikControls";
import { NASMissingFieldsIndicator } from "components/MissingFieldsIndicator";

import { ForCattle, ForSheep } from "containers/ForSpecies";

import { sectionHasErrors } from "lib/form";

import { useFieldValue } from "hooks";

import { Cattle as AdvancedCattleDrafting } from "./Cattle";
import { Sheep as AdvancedSheepDrafting } from "./Sheep";

interface AdvancedDraftingCollapseProps {
  isOpen?: boolean;
  onToggle?: () => void;
  saleLot: Partial<SaleLot>;
  commonProps: { errors: Record<string, unknown> };
  onChangeBreed: (breedId: string | number | null) => void;
  namespace?: string;
  readOnly?: boolean;
}

export const AdvancedDraftingCollapse = ({
  isOpen,
  onToggle,
  saleLot,
  commonProps,
  onChangeBreed,
  namespace,
  readOnly,
}: AdvancedDraftingCollapseProps): React.JSX.Element => {
  const hasErrorBadge = sectionHasErrors(commonProps, ["advancedBreed"]);
  const id = useFieldValue(withNamespace(namespace, "id"));

  // Only NAS indicator is shown (required fields for MLA get hoisted into general section)
  const header = (
    <Grid container>
      <SubtleBadge hasErrorBadge={hasErrorBadge}>Advanced Drafting</SubtleBadge>
      <CollapseLabel />
      <NASMissingFieldsIndicator onlyAdvancedFields keyValue={id} />
    </Grid>
  );

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      id="collapse-advanced"
      dataTour={isOpen ? "hideAdvanced" : "showAdvanced"}
    >
      <Grid container spacing={2}>
        <ForSheep>
          <AdvancedSheepDrafting
            saleLot={saleLot}
            onChangeBreed={onChangeBreed}
            namespace={namespace}
            readOnly={readOnly}
          />
        </ForSheep>
        <ForCattle>
          <AdvancedCattleDrafting
            saleLot={saleLot}
            onChangeBreed={onChangeBreed}
            namespace={namespace}
            readOnly={readOnly}
          />
        </ForCattle>
      </Grid>
    </FormCollapse>
  );
};
